import { createFolder, updateFolder, deleteFolder } from 'slices/lists/folders';
import type { AppDispatch } from 'store/index';
import type { Folder } from 'types/api/folder';
import { EchoChannel as Channel } from '../index';

export default (
  channel: Channel,
  dispatch: AppDispatch
) => {
  channel.listen('.create_folder', (data: any) => {
    const folder = data.data.response as Folder;
    dispatch(createFolder(folder));
  });
  channel.listen('.update_folder', (data: any) => {//
    const folder = data.data.response as Folder;
    dispatch(updateFolder(folder));
  });
  channel.listen('.delete_folder', (data: any) => {//
    const folder = data.data.response as Folder;
    dispatch(deleteFolder(folder));
  });
}